export default {"src":"/_next/static/media/earth-image.7f01c191.svg","height":872,"width":492,"blurWidth":0,"blurHeight":0};